/** Copyright (c) 2019 T. Rowe Price. All rights reserved. */

/**
 * Options below are for DST mutual funds per [DE41258](https://rally1.rallydev.com/#/?detail=/defect/621431994585&fdp=true)
 */
export const costBasisMethodOptions = [
  {
    label: 'First In First Out',
    value: 1,
    includedForMF: true,
    includedForRAS: true
  },
  {
    label: 'Last In First Out',
    value: 2,
    includedForMF: true,
    includedForRAS: true
  },
  {
    label: 'High Cost',
    value: 3,
    includedForMF: true,
    includedForRAS: true
  },
  {
    label: 'High Cost Long-Term',
    value: 4,
    includedForMF: false,
    includedForRAS: true
  },
  {
    label: 'High Cost Short-Term',
    value: 5,
    includedForMF: false,
    includedForRAS: true
  },
  {
    label: 'Low Cost',
    value: 6,
    includedForMF: true,
    includedForRAS: true
  },
  {
    label: 'Low Cost Long-Term',
    value: 7,
    includedForMF: false,
    includedForRAS: true
  },
  {
    label: 'Low Cost Short-Term',
    value: 8,
    includedForMF: false,
    includedForRAS: true
  },
  {
    label: 'Average Cost',
    value: 10,
    includedForMF: true,
    includedForRAS: true
  },
  {
    label: 'Average Cost Using First In First Out',
    value: 10,
    includedForMF: false,
    includedForRAS: false
  },
  {
    label: 'Specific Lot Identification',
    value: 11,
    includedForMF: true,
    includedForRAS: true
  },
  {
    label: 'Loss/Gain Utilization',
    value: 12,
    includedForMF: true,
    includedForRAS: true
  },
  {
    label: 'Minimized Short Term Gains',
    value: 13,
    includedForMF: false,
    includedForRAS: true
  },
  {
    label: 'Average Cost using First in First Out',
    value: 14,
    includedForMF: false,
    includedForRAS: false
  }
];

export const brokerageCostBasisElections = [
  {
    label: 'First In First Out',
    value: 1,
    includedForBrokerageStockInvestment: true,
    includedForBrokerageMutualFund: true,
    includedForBrokerageotherSecurities: true
  },
  {
    label: 'Last In First Out',
    value: 2,
    includedForBrokerageStockInvestment: true,
    includedForBrokerageMutualFund: true,
    includedForBrokerageotherSecurities: true
  },
  {
    label: 'High Cost',
    value: 3,
    includedForBrokerageStockInvestment: true,
    includedForBrokerageMutualFund: true,
    includedForBrokerageotherSecurities: true
  },
  {
    label: 'High Cost Long-Term',
    value: 4,
    includedForBrokerageStockInvestment: true,
    includedForBrokerageMutualFund: true,
    includedForBrokerageotherSecurities: true
  },
  {
    label: 'High Cost Short-Term',
    value: 5,
    includedForBrokerageStockInvestment: true,
    includedForBrokerageMutualFund: true,
    includedForBrokerageotherSecurities: true
  },
  {
    label: 'Low Cost',
    value: 6,
    includedForBrokerageStockInvestment: true,
    includedForBrokerageMutualFund: true,
    includedForBrokerageotherSecurities: true
  },
  {
    label: 'Low Cost Long-Term',
    value: 7,
    includedForBrokerageStockInvestment: true,
    includedForBrokerageMutualFund: true,
    includedForBrokerageotherSecurities: true
  },
  {
    label: 'Low Cost Short-Term',
    value: 8,
    includedForBrokerageStockInvestment: true,
    includedForBrokerageMutualFund: true,
    includedForBrokerageotherSecurities: true
  },
  {
    label: 'Minimized Short Term Gains',
    value: 13,
    includedForBrokerageStockInvestment: true,
    includedForBrokerageMutualFund: true,
    includedForBrokerageotherSecurities: true
  },
  {
    label: 'Average Cost using First In First Out',
    value: 99,
    includedForBrokerageStockInvestment: true,
    includedForBrokerageMutualFund: true,
    includedForBrokerageotherSecurities: false
  }
];

export const getBrokerageOptions = (
  isBrokerageMutualFund,
  isBrokerageStockReinvestment
) => {
  return isBrokerageMutualFund
    ? brokerageCostBasisElections.filter(
        (option) => option.includedForBrokerageMutualFund
      )
    : isBrokerageStockReinvestment
    ? brokerageCostBasisElections.filter(
        (option) => option.includedForBrokerageStockInvestment
      )
    : brokerageCostBasisElections.filter(
        (option) => option.includedForBrokerageotherSecurities
      );
};

export const getCostBasisOptions = (
  isActiveAdvisory = false,
  isBrokerage = false,
  isBrokerageMutualFund = false,
  isBrokerageStockReinvestment = false
) => {
  return isActiveAdvisory
    ? costBasisMethodOptions.filter((option) => option.includedForRAS)
    : isBrokerage
    ? getBrokerageOptions(isBrokerageMutualFund, isBrokerageStockReinvestment)
    : costBasisMethodOptions.filter((option) => option.includedForMF);
};

export const getCostBasisMethodName = (costBasisTypeId, isActiveAdvisory) => {
  const filteredArr = getCostBasisOptions(isActiveAdvisory);
  const filterOption =
    costBasisTypeId &&
    filteredArr.some((option) => option.value === costBasisTypeId);
  return filterOption
    ? filteredArr.find((option) => option.value === costBasisTypeId).label
    : '';
};

const toAverageCostUserAgreement =
  'For account(s) that I have selected Average Cost, I agree to select the average cost method as the covered shares cost basis method applicable to the selected account(s). I understand the tax consequences of selecting this cost basis method and had the opportunity to consult with my tax advisor before I made this selection. Once a sale or other disposition has occurred with respect to a fund, I understand that I cannot revoke the average cost method for that fund, and any new method I selected would only be applied to shares acquired after the change';
const fromAverageCostUserAgreement =
  'For account(s) that I have changed from Average Cost to another method, I agree to change my covered shares cost basis method for the selected account(s) from Average Cost to the method(s) that I have selected. I understand that this change will be treated as a revocation of the Average Cost method for all covered securities in the selected account(s) if revocation is permissible under the applicable tax regulations; and I understand that if revocation is not permissible under the applicable tax regulations, this change will be applied only to shares acquired after I change from the Average Cost method. I understand the tax consequences of making this change and had the opportunity to consult with my tax advisor before I made this change in method.';

export const SPECIFIC_LOT_IDENTIFICATION = 11;
export const AVERAGE_COST = 10;
export const AVERAGE_COST_FIRST_IN_FIRST_OUT = 99;

export const generateCostBasisPayload = (
  costBasisElections,
  pendingCostBasisElections
) => {
  const modifiedCostBasisElections = [];
  let changedFromAverageCost = false;
  let changedToAverageCost = false;

  pendingCostBasisElections.forEach((pendingCostBasisElection) => {
    const pendingAccountId =
      pendingCostBasisElection.accountDescriptor.accountId;
    const existingConstBasisElection = costBasisElections.find(
      (currentCostBasisElection) => {
        const existingAccountId =
          currentCostBasisElection.accountDescriptor.accountId;
        return existingAccountId === pendingAccountId;
      }
    );

    const pendingCostBasisTypeId = pendingCostBasisElection.costBasisTypeId;
    const currentCostBasisTypeId = existingConstBasisElection.costBasisTypeId;
    if (pendingCostBasisTypeId !== currentCostBasisTypeId) {
      let userAgreement = '';
      if (
        currentCostBasisTypeId !== AVERAGE_COST &&
        pendingCostBasisTypeId === AVERAGE_COST
      ) {
        changedToAverageCost = true;
        userAgreement = toAverageCostUserAgreement;
      } else if (
        currentCostBasisTypeId === AVERAGE_COST &&
        pendingCostBasisTypeId !== AVERAGE_COST
      ) {
        changedFromAverageCost = true;
        userAgreement = fromAverageCostUserAgreement;
      }
      modifiedCostBasisElections.push({
        ...pendingCostBasisElection,
        userAgreement,
        costBasisMethod: getCostBasisMethodName(pendingCostBasisTypeId),
        disposition: {
          action: 'update'
        }
      });
    }
  });

  return {
    changedFromAverageCost,
    changedToAverageCost,
    modifiedCostBasisElections
  };
};
